import {
  KPI,
  RFQActivity,
  Readiness,
  Activity,
  Alert
} from "../types/dashboard/dashboard.types";

/* ================= KPI ================= */

export const kpis: KPI[] = [
  { label: "Suppliers actifs", value: 1245, icon: "industry" },
  { label: "RFQ actifs", value: 320, icon: "file" },
  { label: "Réponses", value: 890, icon: "message" },
  { label: "OEM Ready", value: "65%", icon: "check" }
];

/* ================= RFQ ACTIVITY ================= */

export const rfqActivity: RFQActivity[] = [
  { day: "Mon", rfq: 12 },
  { day: "Tue", rfq: 18 },
  { day: "Wed", rfq: 10 },
  { day: "Thu", rfq: 22 },
  { day: "Fri", rfq: 16 }
];

/* ================= READINESS ================= */

export const readiness: Readiness[] = [
  { name: "OEM Ready", value: 65 },
  { name: "Upgrade", value: 25 },
  { name: "Blocked", value: 10 }
];

/* ================= ACTIVITY ================= */

export const activities: Activity[] = [
  {
    type: "Supplier",
    name: "ABC Industrie",
    date: "Aujourd’hui"
  },
  {
    type: "RFQ",
    name: "Pièce moteur",
    date: "Hier"
  },
  {
    type: "Response",
    name: "Offre envoyée",
    date: "Il y a 2 jours"
  }
];

/* ================= ALERTS ================= */

export interface DashboardAlert {
  message: string;
  type: "high" | "medium" | "low";
  date: string;
  supplier?: string;
  rfq?: string;
}

export const alerts: DashboardAlert[] = [
  {
    message: "Blocage foncier - Supplier X",
    type: "high",
    date: "18 Mar 2026"
  },
  {
    message: "Certification ISO 9001 manquante - Supplier Y",
    type: "medium",
    date: "17 Mar 2026"
  },
  {
    message: "Besoin formation industrielle - Supplier Z",
    type: "low",
    date: "16 Mar 2026"
  },
  {
    message: "Capacité insuffisante pour RFQ #245",
    type: "high",
    date: "15 Mar 2026"
  }
];